<template>
    <q-card class="full-height bg-white relative-position">
        <q-card-title class="text-center bg-primary text-white">
            {{ $t('my_score') }}
        </q-card-title>

        <q-card-separator />

        <q-card-main class="text-center" :class="!home ? 'q-my-md' : 'q-mt-md'">
            <q-knob :value="getScore(score)" :max="maxScore" color="primary" size="60%" style="font-size: 2rem" readonly />
        </q-card-main>

        <q-card-actions class="justify-center" :class="!home ? 'q-mt-lg' : ''">
            <q-list no-border separator dense v-if="score_statement && score_statement.length > 0">
                <q-item>
                    <q-item-main>
                        <span class="cursor-pointer text-faded" @click="showStatement()">{{ $t('see_statement') }}</span>
                    </q-item-main>
                </q-item>
            </q-list>
        </q-card-actions>

        <q-inner-loading :visible="score == null">
            <q-spinner-dots :size="60" color="secondary"></q-spinner-dots>
        </q-inner-loading>
    </q-card>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    i18nOptions: { namespaces: [ "custom", "common", "feed", "profile"] },

    props: ['score', 'score_statement', 'home'],

    data() {
        return {

        }
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            clients: 'params/clients',
            id_user_client_selected: 'common/id_user_client_selected'
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        maxScore() {
            return this.score * 1.5
        }
    },

    methods: {
        showStatement() {
            this.$emit('showStatement')
        },

        getScore(score){
            if (score || score === 0) {
                let client = this.clients.find((obj) => { return obj.id === this.id_user_client_selected })

                if (client && client.ranking_use_decimal) return parseFloat(score.toFixed(2))
                else return parseInt(score.toFixed(0))
            }
            else return 0
        }
    }
}
</script>

<style>

</style>
